export default "__VITE_ASSET__CGnpCONq__"